import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, Plus, ArrowUpRight } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { categories } from '../../data/mock';

const ProductCard = ({ product, variant = 'default' }) => {
  const { addToCart } = useCart();
  const category = categories.find(c => c.id === product.categoryId);

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product);
  };

  return (
    <Link
      to={`/product/${product.slug}`}
      className="group block bg-white border-2 border-ink-100 hover:border-athletic-500 transition-all duration-300 overflow-hidden"
    >
      {/* Image */}
      <div className="relative aspect-square bg-ink-50 overflow-hidden">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
        />

        {/* Diagonal badge */}
        {product.badge && (
          <div className="absolute top-4 left-0">
            <span className="inline-block bg-athletic-500 text-white text-[10px] font-black tracking-[0.2em] uppercase px-4 py-1.5 relative shadow-lg">
              {product.badge}
              <span className="absolute top-0 right-[-8px] h-full w-0 border-t-[30px] border-t-athletic-500 border-r-[8px] border-r-transparent" />
            </span>
          </div>
        )}

        {/* Quick Add overlay */}
        <button
          onClick={handleAddToCart}
          aria-label="Quick add to cart"
          className="absolute bottom-0 right-0 w-12 h-12 bg-ink-900 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 hover:bg-athletic-500 transition-all duration-300"
        >
          <Plus className="w-5 h-5" />
        </button>
      </div>

      {/* Info */}
      <div className="p-5">
        <p className="text-[10px] text-ink-400 font-bold uppercase tracking-[0.25em] mb-2">
          {category?.name || 'Sports Gear'}
        </p>
        <h3 className="font-bold text-ink-900 text-[15px] leading-snug mb-3 group-hover:text-athletic-500 transition-colors line-clamp-2 min-h-[44px]">
          {product.name}
        </h3>

        <div className="flex items-end justify-between pt-3 border-t border-ink-100">
          <div>
            <p className="text-[10px] text-ink-400 uppercase tracking-wider">From</p>
            <p className="text-2xl font-black text-ink-900 leading-none">
              ${product.price.toFixed(2)}
            </p>
          </div>
          <button
            onClick={handleAddToCart}
            className="flex items-center gap-1.5 px-3 py-2 bg-ink-900 hover:bg-athletic-500 text-white text-[11px] font-black uppercase tracking-wider transition-colors"
          >
            <ShoppingBag className="w-3.5 h-3.5" />
            Add
          </button>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
